import React, { useState } from 'react';
import HeaderSection from '../../../common/Header/HeaderSection';
import styles from './QueueMonitor.module.scss';
import QueueList from './QueueList';

const AdminHeaderSection = ({ title }) => {
  return (    
    <>
      <div className={styles['queue-header']}>
        <HeaderSection className={styles['header']} title={title} >
        </HeaderSection>
      </div>
      <QueueList/>
    </>
  );
};

export default AdminHeaderSection;
